import { render, staticRenderFns } from "./LiveVoting.vue?vue&type=template&id=2b0a398d&scoped=true&"
import script from "./LiveVoting.vue?vue&type=script&lang=js&"
export * from "./LiveVoting.vue?vue&type=script&lang=js&"
import style0 from "./LiveVoting.vue?vue&type=style&index=0&id=2b0a398d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0a398d",
  null
  
)

export default component.exports